module.exports = __webpack_public_path__ + "static/media/img_vision_texture.efa4fb32.jpg";